import { useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";

// ✅ CRA-friendly worker config
pdfjs.GlobalWorkerOptions.workerSrc =
  process.env.PUBLIC_URL + "/pdf.worker.min.js";

function PdfViewer() {
  const [numPages, setNumPages] = useState(null);

  return (
    <div>
      <Document
        file="/tos.pdf"
        onLoadSuccess={({ numPages }) => setNumPages(numPages)}
      >
        <Page pageNumber={1} />
      </Document>

      <p>Total pages: {numPages}</p>
    </div>
  );
}

export default PdfViewer;
